import { CompareArrows, Inventory2Outlined, Search } from "@mui/icons-material";
import { Chip } from "@mui/material";

type ChatKindChipProps = {
  kind: string;
};

const KIND_CONFIG: Record<
  string,
  { label: string; color: "primary" | "secondary" | "info"; icon: JSX.Element }
> = {
  run: {
    label: "Part",
    color: "primary",
    icon: <Inventory2Outlined fontSize="small" />,
  },
  search: {
    label: "Search",
    color: "info",
    icon: <Search fontSize="small" />,
  },
  comparison: {
    label: "Comparison",
    color: "secondary",
    icon: <CompareArrows fontSize="small" />,
  },
};

const ChatKindChip = ({ kind }: ChatKindChipProps) => {
  const config = KIND_CONFIG[kind];
  if (!config) return null;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="small"
      variant="outlined"
      sx={{
        fontWeight: 500,
        fontSize: "0.75rem",
        pl: 0.5,
        "& .MuiChip-icon": { ml: 0.5 },
      }}
    />
  );
};

export default ChatKindChip;

/**
 * A `renderChatBadge`/`renderBadge` callback for AllChats/RecentChats/
 * RecentChatCard — those components are shared across products, so they
 * accept a badge renderer instead of importing this Parts-AI-specific chip.
 */
export const renderChatKindBadge = (dialogue: { kind?: string | null }) =>
  dialogue.kind ? <ChatKindChip kind={dialogue.kind} /> : null;
